import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import InsightsArticle from "./components/Insights/InsightsArticle";
import ScrollTop from "./components/Helper/ScrollTop";
import Error from "./components/Error";
import Home from "./components/Home/index";
import HomeV2, { ContactPage, CareersPage, InsightsPage } from "./components/HomeV2/HomeV2";
import Administrator from "./components/Administrator/index";
import WhyDsider from "./components/WhyDsider/index";
import Features from "./components/Features/index";
import OurTeams from "./components/OurTeams/OurTeams";
import ClimateTech from "./components/IndustryLeadersPages/ClimateTech";
import Agencies from "./components/IndustryLeadersPages/Agencies";
import Companies from "./components/IndustryLeadersPages/Companies";
import Financials from "./components/IndustryLeadersPages/Financials";
import EngineeringFirms from "./components/IndustryLeadersPages/EngineeringFirms";
import BlogsPage from "./components/BlogsPage/BlogsPage";
import NewsPage from "./components/NewsPage/NewsPage";
import MoveToTop from "./components/MoveToTop/MoveToTop";
import NewsDetailpage from "./components/NewsPage/NewsDetailpage";
import JobDetail from "./components/Opportunities/JobDetail";
import Midstream from "./components/Products/Midstream";
import Upstream from "./components/Products/Upstream";
import EnergyTransition from "./components/Products/EnergyTransition";
function App() {
  return (
    <>
      {/* <Router basename="/name"> */}
      <Router>
        <ScrollTop />
        <Routes>
          <Route path="*" element={<Error />} />
          <Route path="/" element={<HomeV2 />} />
          <Route path="/use-cases" element={<Home section="use-cases" />} />
          <Route path="/administrator" element={<Administrator />} />
          <Route path="/why-dsider" element={<WhyDsider />} />
          <Route path="/features" element={<Features />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:id" element={<InsightsArticle />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:id" element={<NewsDetailpage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/technology" element={<Home section="technology" />} />
          <Route path="/products" element={<Home section="products" />} />
          <Route path="/midstream" element={<Midstream />} />
          <Route path="/upstream" element={<Upstream />} />
          <Route path="/energy-transition" element={<EnergyTransition />} />
          <Route path="/offerings" element={<Home section="offerings"/>} />
          <Route path="/team" element={<OurTeams />} />
          <Route path="/industries" element={<Home section="industries" />} />
          <Route path="/climate-tech" element={<ClimateTech />} />
          <Route path="/government-agencies" element={<Agencies />} />
          <Route path="/industrial-companies" element={<Companies />} />
          <Route path="/financial-institutions" element={<Financials />} />
          <Route path="/engineering-companies" element={<EngineeringFirms />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/Careers/Jobs/:jobId" element={<JobDetail />} />
        </Routes>
        <MoveToTop />
      </Router>
    </>
  );
}

export default App;
